var exports = {
  "kL": "xe564cbfb--a02c63--container",
  "Kk": "xe564cbfb--a02c63--icon",
  "y_": "xe564cbfb--a02c63--remoteness",
};

module.exports = exports;
